export default {
	//다국어 Map에서 key 값을 이용해 다국어 메세지를 return하는 Getter
	getMessage_: state => key => {
		if (!state.userMessage.size || !key) return null;

		return state.userMessage && state.userMessage.size > 0 && state.userMessage.get(key) ? state.userMessage.get(key) : key;
	},

	//사용자 정보를 return하는 Getter
	getUser_: state => {
		let user = {}; //사용자 정보가 없을 경우 빈 객체 반환
		if (state.user && state.user.userId && state.user.userPwd) {
			//사용자 정보가 있을 경우 사용자 정보 Return
			user = { userId: state.user.userId, userPw: state.user.userPwd.split(':')[0] };
		}

		return user;
	},

	//세션 남은 시간을 s => hh:mm:ss 포맷으로 return하는 Getter
	remainingTime_: state => time => {
		let temp = time;

		let hours = parseInt(temp / 3600);
		temp -= hours * 3600;

		let minutes = parseInt(temp / 60);
		let seconds = temp - minutes * 60;

		if (hours > 0) return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2);
		else return pad(minutes, 2) + ':' + pad(seconds, 2);
	},

	//name이나 type을 이용해서 메뉴를 검색하여 return하는 Getter
	getMenu_:
		state =>
		({ name, type }) => {
			let result = {};
			for (let menu of state.menuMap.values()) {
				if (name === menu.scrName || type === menu.scrType) {
					result = menu;
				}
			}
			return result;
		},

	getButtonMsg_: state => (scrId, key) => {
		if (!key) return null;
		return state.screenArray.get(scrId).screenBtn && state.screenArray.get(scrId).screenBtn.get(key)
			? state.userMessage.get(state.screenArray.get(scrId).screenBtn.get(key).msgKey)
			: key;
	},

	isButton_: state => (scrId, key) => {
		return state.screenArray.get(scrId).screenBtn && state.screenArray.get(scrId).screenBtn.get(key) ? true : false;
	},

	getVuexVariable_: state => key => {
		return state[key];
	}
};

//초를 문자로 변환하기 위한 함수
function pad(n, width) {
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
}
